import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './sentry'
import './index.css'
import App from './App.jsx'
import './i18n/config'

createRoot(document.getElementById('root')).render(
  <>
    <App />
  </>
)
